import React from "react";
import { ConnectedProps, connect } from "react-redux";
import "./index.css";
import MapComponent from "../../components/Map";
import { ReducerState } from "../../types";
import DetectionActivity from "../../components/DetectionActivity";
import TrapLocationTable from "../../components/TrapLocations";
import TrapStatus from "../../components/TrapStatus";
import ActivityDisplay from "../../components/ActivityDisplay";
import { Typography } from "antd";

const { Title } = Typography;

const connector = connect(null, {});

type Props = ConnectedProps<typeof connector> & {
  // Extra props go here
};

const Home: React.FC<Props> = () => {
  return (
    <div className="home-container flex flex-col pb-8">
      <div className="mx-6 mt-6 ">
        <Title level={2}> Surveillance Activity</Title>
      </div>
      <div className="flex flex-row gap-4 mx-6 justify-center">
        <ActivityDisplay />
      </div>

      <div className="mx-6 flex gap-6 mt-0 h-150">
        <div className="w-3/6 shrink-0 py-6 h-full">
          <DetectionActivity />
        </div>
        <div className="flex-1 h-full">
          <MapComponent />
        </div>
      </div>

      <div className="mx-6 flex flex-row gap-6 h-full">
        <div className="flex-1 min-w-0">
          <TrapLocationTable />
        </div>
        <div className="w-2/6 shrink-0 h-full">
          <TrapStatus />
        </div>
      </div>
    </div>
  );
};

export default connector(Home);
